<template>
<div class="p-2">
  <b-form>
    <b-row>
      <b-col>
        <b-form-group label="Major:" label-for="constraingMajor">
          <b-form-select :options="majorOptions" id="constraingMajor" v-model="major" required placeholder="Please, select option"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Minor:" label-for="constraingMinor">
          <b-form-select :options="minorOptionsFiltered" id="constraingMinor" v-model="minor" required placeholder="Please, select option"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Buffer dist (m):" label-for="constraingMinor">
          <b-input type="number" v-model="buffer_dist_m" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Cause:" label-for="constrainingCause">
          <b-form-checkbox-group :options="causeOptions" id="constrainingCause" v-model="cause"></b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Comments:" label-for="constraingMinor">
          <b-textarea v-model="comments" rows="3" />
        </b-form-group>
      </b-col>
    </b-row>
        <div class="form-group">
          <label>Images:</label>
          <div class="card p-2">
            <vue-clip ref="vc" :options="uploadOptions" :on-complete="onComplete" :on-max-files="onMaxFiles" :on-added-file="onAddedFile">

              <template slot="clip-uploader-action">
                <div>
                  <div class="dz-message m-2 p-1 drop-zone"><p class="card-text">
                    Click or drag here </p></div>
                </div>
              </template>
              <template slot="clip-uploader-body" slot-scope="props">
                <div class="card-columns">
                  <div class="card uploading-image"
                       v-for="(file, i) in props.files.filter(function(f){return !f.customAttributes.ignore})">
                    <b-progress :value="file.progress" :max="100" show-progress :animated="file.progress<100">
                      <icon v-if="file.progress==100" @click.native="removeFile(file)" class="close-file"
                            name="times"></icon>
                    </b-progress>
                    <img width="70" class="card-img-bottom" v-bind:src="file.dataUrl"/>
                    <!--{{ file.name }} {{ file.status }} {{ file.customAttributes.id }}-->
                  </div>
                </div>
              </template>
            </vue-clip>

            <div class="card p-2 mt-2" v-if="existingPhotos.length">
              <div class="card-columns">
                <div class="card uploading-image" v-for="(file, i) in existingPhotos">
                  <b-progress :value="100" :max="100">
                    <icon @click.native="removeExisting(file)" class="close-file" name="close"></icon>
                  </b-progress>
                  <img width="70" class="card-img-bottom" v-bind:src="'/api/uploads/view-image/?id='+file.id"/>
                </div>
                </div>
              </div>
            </div>
          </div>
  </b-form>
</div>
</template>

<script>
export default {
  name: 'constraints-form',
  data() {
    return {
      photos: {},
      newPhotos: {},
      existingPhotos: [],
      major: 'None',
      minor: '',
      cause: [],
      comments: '',
      buffer_dist_m: 0,
      minorOptionsFiltered: [],
      causeOptions: [],
      majorOptions: []
    }
  },
  computed: {
    uploadOptions() {
      return {
        url: '/api/uploads/upload-file',
        paramName: 'file',
        acceptedFiles: {
          extensions: ['image/png', 'image/jpeg']
        },
        maxFilesize: {
          limit: 20,
          message: 'File size limit eceeded (20MB)'
        },
        maxFiles: {
          limit: 20 - this.existingPhotos.length,
          message: 'Possible to upload at maximum 20 files'
        }
      }
    }
  },
  watch: {
    major(val) {
      this.minorOptionsFiltered = this.options.filter(o => o.major === val).map(o => o.minor)
      this.emitValue()
    },
    minor(val) {
      this.emitValue()
    },
    cause(val) {
      this.emitValue()
    },
    comments(val) {
      this.emitValue()
    },
    buffer_dist_m(val) {
      this.emitValue()
    },
    options(val) {
      let map = {}
      val.forEach(o => map[o.major] = true)
      this.majorOptions = Object.keys(map)
      this.majorOptions.push('None')
    },
    causes(val) {
      this.causeOptions = val
    },
    value(val) {
      this.setValue(val)
    },
    featureId(val) {
      this.loadExistingPhotos()
    },
    existingPhotos(val) {
      val.forEach(p => this.photos[p.id] = true)
    }

  },
  mounted() {
    let map = {}
    this.options.forEach(o => map[o.major] = true)
    this.majorOptions = Object.keys(map)
    this.majorOptions.push('None')
    this.causeOptions = this.causes
    this.setValue(this.value)
  },
  props: {
    value: {
      default: null
    },
    options: {
      default: () => []
    },
    featureId: {
      default: null
    },
    causes: {
      default: () => []
    },
    type: {
      default: 'Polygon'
    }
  },
  methods: {
    setValue(val) {
      if (val) {
        if (val['cause'] && val['cause'].length > 1 && this.cause.length !== val['cause'].split(',').length) {
          this.cause = val['cause'].split(',')
        } else if (!val['cause'] && this.cause.length > 0) {
          this.cause = []
        }
        console.log('test constraint value')
        console.log(val['major'])
        this.major = val['major']
        this.minor = val['minor']
        this.comments = val['comments']
        this.buffer_dist_m = val['buffer_dist_m']
      }
    },
    emitValue() {
      this.$emit('input', {
        'major': this.major,
        'minor': this.minor,
        'photos': Object.keys(this.photos).join(','),
        'buffer_dist_m': this.buffer_dist_m,
        'comments': this.comments,
        'cause': this.cause.join(),
        'geo_type': this.type
      })
    },
    loadExistingPhotos() {
      console.log('loading photos: ' + this.featureId)
      this.$http.get('/api/uploads/get-constraint-photos', {
          params: {
            id: this.featureId
          }
        })
        .then(res => {
          this.existingPhotos = res.body
        }, res => {
          console.error(res)
        })
    },
    onComplete(file, status, xhr) {
      if (!xhr) {
        return
      }

      try {
        let res = JSON.parse(xhr.response)
        let id = parseInt(res.ids[0])
        file.addAttribute('id', id)
        this.photos[id] = true
        this.newPhotos[id] = true
      } catch (e) {
        file.addAttribute('error', true)
      }
      this.emitValue()
    },
    onMaxFiles(file) {
      file.addAttribute('ignore', true)
    },
    removeFile(file) {
      this.$refs.vc.removeFile(file)
      let index = this.$refs.vc.files.indexOf(file)
      if (index > -1) {
        this.$refs.vc.files.splice(index, 1)
      }

      if (file.customAttributes.id) {
        delete this.photos[file.customAttributes.id]
      }
      this.emitValue()
    },
    removeExisting(f) {
      let index = this.existingPhotos.map(e => e.id).indexOf(f.id)
      if (index > -1) {
        this.existingPhotos.splice(index, 1)
        console.log(this.$refs.vc.uploader._uploader)
        this.$refs.vc.uploader._uploader.options.maxFiles = 20 - this.existingPhotos.length
        //          this.$refs.vc.uploader._options.maxFiles = 10 - this.existingPhotos.length
      }
      delete this.photos[f.id]
      this.emitValue()
    },
    onAddedFile(file) {}
  }
}
</script>

<style lang="scss">
.uploading-image {
    position: relative;
}

.uploading-image:hover .close-file {
    opacity: 1;
}

.close-file {
    position: absolute;
    right: 0.3rem;
    cursor: pointer;
    color: white;
    opacity: 0.6;
}

.drop-zone {
    cursor: pointer;
    border: 2px dashed lightgray;
}

#constrainingCause {
    .custom-control-description {
        padding-top: 9px;
    }
    .custom-control.custom-checkbox {
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/map/designotron/ConstraintsForm.vue